/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type settingsHolidayCalendars_holidayCalendarEntry = {
    readonly id: string;
    readonly name: string | null;
    readonly year: number | null;
    readonly month: number | null;
    readonly day: number | null;
    readonly " $refType": "settingsHolidayCalendars_holidayCalendarEntry";
};
export type settingsHolidayCalendars_holidayCalendarEntry$data = settingsHolidayCalendars_holidayCalendarEntry;
export type settingsHolidayCalendars_holidayCalendarEntry$key = {
    readonly " $data"?: settingsHolidayCalendars_holidayCalendarEntry$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"settingsHolidayCalendars_holidayCalendarEntry">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "settingsHolidayCalendars_holidayCalendarEntry",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "year",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "month",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "day",
      "storageKey": null
    }
  ],
  "type": "HolidayCalendarEntry"
};
(node as any).hash = '25995f24e90648ba38cad2d1218dade4';
export default node;
